import { MouseEventHandler } from "react";

import styled from "styled-components";

import { Frame, Row, RowWrapper } from "components/ui-kit/styled-templates";

const RecordTab = (props: {
    title: string;
    description: string;
    tableData: { title: string; value: any }[];
    onEditClick: MouseEventHandler<HTMLDivElement>;
    onDeleteClick: MouseEventHandler<HTMLDivElement>;
}) => {
    const { title, description, tableData, onEditClick, onDeleteClick } = props;
    return (
        <Record.Wrapper>
            <RowWrapper>
                <h3>{title}</h3>
                <Row extra={`gap: 0 20px;`}>
                    <Record.EditIcon onClick={onEditClick} />
                    <Record.DeleteIcon onClick={onDeleteClick} />
                </Row>
            </RowWrapper>
            <RowWrapper>
                {tableData.map((item, index) => (
                    <Record.Column key={index}>
                        <div>{item.title}:</div>
                        <strong>{item.value}</strong>
                    </Record.Column>
                ))}
            </RowWrapper>
            <Frame extra={`width: inherit; margin-top: 24px; align-items: flex-start;`}>{description}</Frame>
        </Record.Wrapper>
    );
};

const Icon = styled(Frame)`
    width: 24px;
    height: 24px;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`;

const Record = {
    Wrapper: styled(Frame)`
        background: rgba(201, 212, 219, 0.1);
        border-radius: 2px;
        padding: 20px 30px;
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 20px;
        align-items: flex-start;
    `,
    EditIcon: styled(Icon)`
        background: url("${require(`assets/icons/record-edit.svg`).default}") no-repeat center center / contain;
    `,
    DeleteIcon: styled(Icon)`
        background: url("${require(`assets/icons/record-delete.svg`).default}") no-repeat center center / contain;
    `,
    Column: styled(Frame)`
        align-items: flex-start;
        width: 100%;
        flex: 1;
        font-size: 15px;
        line-height: 20px;
        gap: 8px;
    `,
};

export default RecordTab;
